import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Banks
export const getBanks = () => axios.get(`${API}/banks`);
export const createBank = (data) => axios.post(`${API}/banks`, data);
export const updateBank = (id, data) => axios.put(`${API}/banks/${id}`, data);
export const deleteBank = (id) => axios.delete(`${API}/banks/${id}`);

// Tenants
export const getTenants = () => axios.get(`${API}/tenants`);
export const getTenant = (id) => axios.get(`${API}/tenants/${id}`);
export const createTenant = (data) => axios.post(`${API}/tenants`, data);
export const updateTenant = (id, data) => axios.put(`${API}/tenants/${id}`, data);
export const deleteTenant = (id) => axios.delete(`${API}/tenants/${id}`);
export const syncTenantsFromNotion = () => axios.post(`${API}/tenants/sync-notion`);

// Transactions
export const getTransactions = (bankId) => 
  axios.get(`${API}/transactions`, { params: bankId ? { bank_id: bankId } : {} });
export const createTransaction = (data) => axios.post(`${API}/transactions`, data);
export const matchTransaction = (txId, tenantId) => 
  axios.post(`${API}/transactions/${txId}/match/${tenantId}`);

// Payments
export const getPayments = (tenantId) => 
  axios.get(`${API}/payments`, { params: tenantId ? { tenant_id: tenantId } : {} });
export const createPayment = (data) => axios.post(`${API}/payments`, data);

// Dashboard
export const getDashboardStats = () => axios.get(`${API}/dashboard/stats`);
export const getCashflowHistory = () => axios.get(`${API}/dashboard/cashflow-history`);
export const getFinancialSummary = () => axios.get(`${API}/dashboard/financial-summary`);

// Notifications
export const sendWhatsAppNotification = (tenantId, message) => 
  axios.post(`${API}/notifications/whatsapp`, { tenant_id: tenantId, message });

// Settings
export const getSettings = () => axios.get(`${API}/settings`);
export const updateSettings = (data) => axios.put(`${API}/settings`, data);

// Auto-matching
export const autoMatchTransactions = () => axios.post(`${API}/transactions/auto-match`);

// Enable Banking - Open Banking
export const getAvailableAspsps = (country = "FR") => 
  axios.get(`${API}/banking/aspsps`, { params: { country } });
export const connectBankAccount = (bankName, bankCountry = "FR") => 
  axios.post(`${API}/banking/connect`, null, { params: { bank_name: bankName, bank_country: bankCountry } });
export const getConnectedBanks = () => axios.get(`${API}/banking/connected`);
export const getAccountBalances = (accountUid) => 
  axios.get(`${API}/banking/accounts/${accountUid}/balances`);
export const getAccountTransactions = (accountUid, dateFrom, dateTo) => 
  axios.get(`${API}/banking/accounts/${accountUid}/transactions`, { 
    params: { date_from: dateFrom, date_to: dateTo } 
  });
export const syncBankTransactions = (accountUid, bankId) => 
  axios.post(`${API}/banking/sync-transactions/${accountUid}`, null, { params: { bank_id: bankId } });
export const disconnectBank = (connectedId) => 
  axios.delete(`${API}/banking/connected/${connectedId}`);


// Payment Statistics
export const getPaymentStatsByStructure = (month, year) =>
  axios.get(`${API}/payments/stats-by-structure`, { params: (month && year) ? { month, year } : {} });

// Manual Sync
export const manualSync = () => axios.post(`${API}/sync/manual`);


// Import all Enable Banking accounts
export const importAllBanks = () => axios.post(`${API}/banking/import-all`);


export const getLeases = (tenantId) => 
  axios.get(`${API}/leases`, { params: tenantId ? { tenant_id: tenantId } : {} });
export const getLease = (id) => axios.get(`${API}/leases/${id}`);
export const createLease = (data) => axios.post(`${API}/leases`, data);
export const updateLease = (id, data) => axios.put(`${API}/leases/${id}`, data);
export const deleteLease = (id) => axios.delete(`${API}/leases/${id}`);
export const downloadLeasePdf = (id) => 
  axios.get(`${API}/leases/${id}/pdf`, { responseType: "blob" });
export const generateLeaseRiskReport = (id) =>
  axios.post(`${API}/leases/${id}/risk-report`);

export const getEdls = (tenantId) => 
  axios.get(`${API}/etats-des-lieux`, { params: tenantId ? { tenant_id: tenantId } : {} });
export const getEdl = (id) => axios.get(`${API}/etats-des-lieux/${id}`);
export const createEdl = (data) => axios.post(`${API}/etats-des-lieux`, data);
export const updateEdl = (id, data) => axios.put(`${API}/etats-des-lieux/${id}`, data);
export const deleteEdl = (id) => axios.delete(`${API}/etats-des-lieux/${id}`);
export const downloadEdlPdf = (id) => 
  axios.get(`${API}/etats-des-lieux/${id}/pdf`, { responseType: "blob" });

export const sendLeaseForSignature = (id, data) => axios.post(`${API}/leases/${id}/send-signature`, data);
export const getLeaseSignatureStatus = (id) => axios.get(`${API}/leases/${id}/signature-status`);
export const downloadSignedLeasePdf = (id) =>
  axios.get(`${API}/leases/${id}/signed-pdf`, { responseType: "blob" });


export const getChargesRegulations = (leaseId) =>
  axios.get(`${API}/charges-regulations`, { params: leaseId ? { lease_id: leaseId } : {} });
export const createChargesRegulation = (data) => axios.post(`${API}/charges-regulations`, data);
export const updateChargesRegulation = (id, data) => axios.put(`${API}/charges-regulations/${id}`, data);
export const deleteChargesRegulation = (id) => axios.delete(`${API}/charges-regulations/${id}`);
export const downloadChargesRegulationPdf = (id) =>
  axios.get(`${API}/charges-regulations/${id}/pdf`, { responseType: 'blob' });

// Charges provisionnées — récupération par année
export const getChargesByYear = (year, categories = "tax,expense,maintenance") =>
  axios.get(`${API}/transactions/charges-by-year`, { params: { year, categories } });

// Envoi email régulation des charges
export const sendEmailRegulation = (data) =>
  axios.post(`${API}/notifications/email-regulation`, data);
export const sendLeaseToNotion = (id) => axios.post(`${API}/leases/${id}/send-to-notion`);
export const unmatchTransaction = (txId) => axios.post(`${API}/transactions/${txId}/unmatch`);
